<nav class="navbar navbar-dark bg-primary">
  @if (service.needTemplate === true) {
    <div>
      <a class="navbar-brand center" [routerLink]='[service.currentUser.defaultUrl]'><img src='{{baseUrl + "/styles/header_logo.png"}}' width="100%" height="100%"></a>
    </div>
  }
  <div style="margin: auto 40px auto auto;">
    <h6 style="color: white; margin: 0px;">{{currentTime}}</h6>
  </div>
  @if (service.needTemplate === true) {
    <div class="row float-right mr-1" >
      <div class="circle-with-text clickable" [matMenuTriggerFor]="beforeMenu">
        <b>{{service.currentUser.userInitials}}</b>
      </div>
      <!-- <button class="matbtn1" ><mat-icon>arrow_drop_down</mat-icon></button> -->
      <mat-menu #beforeMenu="matMenu" xPosition="before">
        @if (service.currentUser.userRoles && service.currentUser.userRoles.length > 1) {
          <button mat-menu-item [matMenuTriggerFor]="multipleRoles"><mat-icon>person</mat-icon>{{service.currentUser.userRoles[0].value}}</button>
        }
        @if (azureEnabled == false) {
          <button mat-menu-item (click)="router.navigate(['password']);"><mat-icon fontSet="material-icons-outlined">lock</mat-icon>{{'mainHeader.lblChangePassword' | translate}}</button>
        }
        <button mat-menu-item (click)="logout()"><mat-icon>logout</mat-icon> {{'mainHeader.lblLogout' | translate}}</button>
      </mat-menu>
      <mat-menu #multipleRoles="matMenu">
        @for (role of service.currentUser.userRoles; track role) {
          <button mat-menu-item [disabled]="role.id === service.currentUser.userRoleID" (click)="onChangeUser(role)">{{role.value}}</button>
        }
      </mat-menu>
    </div>
  }
</nav>